export const convertToInitials = (name: string) => {
  if (!name) return '';
  const names = name.split(' ');
  let initials = '';
  for (let i = 0; i < names.length && i < 2; i++) {
    initials += names[i].charAt(0).toUpperCase();
  }
  return initials;
};

/**
 * Converts a string to title case.
 *
 * @param {string} str - The string to be converted.
 * @param {string} [delimiter='_'] - The delimiter used to split the string. Defaults to '_'.
 *
 * If the string is empty or null, it returns an empty string.
 * If the string does not contain the delimiter, it capitalizes the first character of the string and returns it.
 * If the string contains one or more delimiters, it splits the string into an array of substrings at each delimiter.
 * Then, it capitalizes the first character of each substring, joins them together with a space between each, and returns the resulting string.
 *
 * @returns {string} The string converted to title case.
 */
export const toTitleCase = (str: string, delimiter: string = '_') => {
  if (!str) return '';

  if (str.search(delimiter) === -1) {
    return str.charAt(0).toLocaleUpperCase() + str.slice(1).toLocaleLowerCase();
  }

  const arr = str.split(delimiter);
  let output = '';

  for (let i = 0; i < arr.length; i++) {
    output = output + arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLocaleLowerCase() + ' ';
  }

  return output;
};

// We need to handle how to render options coming, they can be string, array's or objects. We need to return a consistent string value every time.
type OptionValue = string | string[] | { values: string | string[] };
// Note: I'm assuming this is a much more widespread issue across this feature, so we should probably refactor this into the core of <IndexPage
// Handle transforming option values in the following ways
// 1 From array to concatenated string
// 2 From object to string
// 3 From object with values as string | array to string

export const returnStringFromOption = (value: OptionValue) => {
  if (!value) return ''; // I suppose value could be an empty string or undefined
  if (Array.isArray(value)) {
    return value?.map((val) => val).join(', ');
  } else if (typeof value === 'object') {
    const { values } = value;
    if (typeof values === 'string') {
      return values;
    } else {
      return values?.map((val) => val).join(', ');
    }
  }
  // Assuming we're just a string, return the string
  return value;
};
